module.exports = __webpack_public_path__ + "0ca52b35674fccef23284c713b112e0f.pdf";